import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/learning";

export const learningApi = {
  listCourses: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.sort) searchParams.set("sort", params.sort);
    if (params?.order) searchParams.set("order", params.order);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/courses?${searchParams.toString()}`);
  },

  getCourse: (id: string) => apiGet<{ course: Record<string, unknown> }>(`${BASE}/courses/${id}`),

  enroll: (courseId: string) => apiPost<{ enrollment: Record<string, unknown> }>(`${BASE}/courses/${courseId}/enroll`),

  unenroll: (courseId: string) => apiPost<{ message: string }>(`${BASE}/courses/${courseId}/unenroll`),

  getProgress: (courseId: string) => apiGet<{ progress: Record<string, unknown> }>(`${BASE}/courses/${courseId}/progress`),

  updateProgress: (courseId: string, data: Record<string, unknown>) =>
    apiPut<{ progress: Record<string, unknown> }>(`${BASE}/courses/${courseId}/progress`, data),

  getMyLearning: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/my-learning?${searchParams.toString()}`);
  },

  getCertificates: () => apiGet<{ certificates: Record<string, unknown>[] }>(`${BASE}/certificates`),
};
